import React, { useCallback, useEffect, useState } from "react";
import {
  BackgroundPage,
  Body1,
  FormPadrao,
  H6,
  Icone,
  Pesquisando,
  ScrollInfinito,
  SemPesquisa,
  TabelaV2,
} from "../../../components";
import { useDispatch, useSelector } from "react-redux";
import { useToggle } from "react-use";
import {
  Button,
  Container,
  Grow,
  IconButton,
  Stack,
  useTheme,
} from "@mui/material";
import {
  cashbackClear,
  cashbackGetData,
  cashbackSetModal,
} from "./reducers/cashback-actions";
import {
  selectIsAdminVoucher,
  selectModal,
  selectTableData,
  selectTableHeader,
} from "./cashback-selectors";
import CashbackItemMobile from "./cashback-item-mobile";
import {
  cashbackIndexTable,
  convertItemToObject,
  getColorStatusCashback,
  getStatusCashback,
  getTitleStatusCashback,
  sendMessageWhatsApp,
} from "./cashback-utils";
import DrawerDialog from "../../../extra-components/drawer-dialog";
import CashbackModal from "./cashback-modal";
import CashbackPanel from "./cashback-panel";
import { optTabela } from "../../../utils/utilitarios";

const STR = {
  title: "Cashback",
  subtitle:
    "A pesquisa para retornar os vouchers disponíveis no cashback se dá pela data de registro do cashback",
  labelValidateSearch: "Validar / Pesquisar",
  titleValidateSearch:
    "Veja opções para validação de voucher ou pesquisa de voucher",
  titleSendWhatsApp:
    "Envia a mensagem com o voucher ao cliente de forma manual, saindo do WhatsApp do usuário logado.",
  labelBtnEdit: "Editar",
  labelBtnNew: "Criar Voucher Manual",
  titleBtnNew:
    "Clique aqui caso deseje criar um novo voucher para um cliente manualmente",
  labelBtnDelete: "Excluir",
  titleBtnDelete: "Clique aqui caso queira excluir o voucher do cliente",
  labelLegend: "Legenda",
  titleLegend: "Legenda dos status do cashback",
};

function Cashback() {
  const dispatch = useDispatch();
  const [wait, setWait] = useToggle();
  const data = useSelector(selectTableHeader);
  const modal = useSelector(selectModal);
  //
  const closeModal = useCallback(() => {
    dispatch(cashbackSetModal(null));
  }, [dispatch]);
  //
  const onSubmit = useCallback(
    (data) => {
      const obj = {
        data_venda: [data.de, data.ate].join("_"),
        extraLojas: data.extraLojas,
      };
      dispatch(cashbackGetData(obj, setWait));
    },
    [dispatch, setWait]
  );

  useEffect(() => {
    dispatch(cashbackClear());
  }, [dispatch]);

  //
  return (
    <BackgroundPage>
      {modal && (
        <DrawerDialog
          fecharModal={closeModal}
          fnGetCorpo={() => <CashbackModal modal={modal} />}
        />
      )}
      <Container maxWidth={false}>
        <H6>{STR.title}</H6>
        <Container maxWidth="lg" disableGutters>
          <FormPadrao aguardar={wait} onClick={onSubmit} />
          <Body1 align="center">{STR.subtitle}</Body1>
        </Container>

        {wait ? <Pesquisando /> : data ? <CashbackPage /> : <SemPesquisa />}
      </Container>
    </BackgroundPage>
  );
}

const CashbackPage = () => {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState("");
  const isMobile = useTheme().isMobile;
  //
  const onValidateSearchVoucher = useCallback(() => {
    dispatch(
      cashbackSetModal({ type: CashbackModal.modal.VALIDATE_AND_SEARCH })
    );
  }, [dispatch]);
  return (
    <Stack sx={{ mt: 1 }}>
      <Container maxWidth="lg" disableGutters>
        <CashbackPanel
          filter={filter}
          setFilter={setFilter}
          onAdd={onValidateSearchVoucher}
          label={STR.labelValidateSearch}
          title={STR.titleValidateSearch}
          icon="SavedSearch"
          noViewSearchBar={!isMobile}
          viewButtonAdd={false}
        />
      </Container>
      {isMobile ? <CashbackMobile filter={filter} /> : <CashbackDesktop />}
    </Stack>
  );
};

const CashbackMobile = ({ filter }) => {
  const dispatch = useDispatch();
  const dataBody = useSelector(selectTableData);
  //
  const onNewCashback = useCallback(() => {
    dispatch(cashbackSetModal({ type: CashbackModal.modal.NEW_CASHBACK }));
  }, [dispatch]);
  // Realizar um filtro no corpo da tabela
  let dataFiltered = dataBody;
  if (filter) {
    dataFiltered = dataBody.filter((item) => {
      const obj = convertItemToObject(item.data);
      return Object.values(obj).some((val) =>
        String(val).toLowerCase().includes(filter.toLowerCase())
      );
    });
  }
  //
  return (
    <Stack>
      <Button
        sx={{ my: 1 }}
        title={STR.titleBtnNew}
        startIcon={<Icone icone="FiberNew" />}
        variant="outlined"
        onClick={onNewCashback}
      >
        {STR.labelBtnNew}
      </Button>
      <ScrollInfinito
        itens={dataFiltered || []}
        itensPorPagina={10}
        render={(item) => (
          <CashbackItemMobile
            key={item.id}
            {...convertItemToObject(item.data)}
          />
        )}
      />
    </Stack>
  );
};

const CashbackDesktop = () => {
  const {
    palette: { styleTrSelecionado },
  } = useTheme();
  const main = styleTrSelecionado.backgroundColor;
  const contrastText = styleTrSelecionado.color;
  const dataBody = useSelector(selectTableData);
  const dataHeader = useSelector(selectTableHeader);

  //
  const optTabelaT = {
    ...optTabela,
    styleTrSelecionado: {
      backgroundColor: main,
      color: contrastText,
    },
    telefone: [cashbackIndexTable.cellPhone],
    monetario: [cashbackIndexTable.valueSale, cashbackIndexTable.valueVoucher],
    data: [cashbackIndexTable.datePraz],
    dataHora: [cashbackIndexTable.dateSend],
    envolver: {
      [cashbackIndexTable.status]: (val) =>
        val ? (
          <span title={getTitleStatusCashback(val)}>
            <Icone
              icone={getStatusCashback(val)}
              color={getColorStatusCashback(val)}
            />
          </span>
        ) : (
          val
        ),
      [cashbackIndexTable.id]: (val, idx, reg) => {
        if (!val) return val;
        const cellPhone = reg.values[cashbackIndexTable.cellPhone];

        return (
          <IconButton
            title={STR.titleSendWhatsApp}
            onClick={(e) => {
              e.stopPropagation();
              sendMessageWhatsApp(val, cellPhone);
            }}
          >
            <Icone icone="WhatsApp" color="success" />
          </IconButton>
        );
      },
    },
  };
  return (
    <TabelaV2
      cabe={dataHeader}
      corpo={dataBody}
      {...optTabelaT}
      render={({ trSelecionado }) => (
        <RenderPanelTable trSelecionado={trSelecionado} />
      )}
    />
  );
};

const RenderPanelTable = ({ trSelecionado }) => {
  const isAdmin = useSelector(selectIsAdminVoucher);
  const dataBody = useSelector(selectTableData);
  const dispatch = useDispatch();
  //
  const onDeleteVoucher = useCallback(
    (id) => {
      dispatch(
        cashbackSetModal({
          type: CashbackModal.modal.DELETE_CASHBACK,
          data: { id },
        })
      );
    },
    [dispatch]
  );

  const onEdit = useCallback(() => {
    const item = dataBody.filter((item) => item.id === trSelecionado)[0];
    dispatch(
      cashbackSetModal({
        type: CashbackModal.modal.UPDATE_CLIENT,
        data: {
          id: trSelecionado,
          name: item.data[cashbackIndexTable.nameClient],
          cellPhone: item.data[cashbackIndexTable.cellPhone],
        },
      })
    );
  }, [dispatch, dataBody, trSelecionado]);

  const onViewLegend = useCallback(() => {
    dispatch(cashbackSetModal({ type: CashbackModal.modal.LEGEND_CASHBACK }));
  }, [dispatch]);

  return (
    <Stack direction="row" spacing={1}>
      <Button
        startIcon={<Icone icone="ListAlt" />}
        title={STR.titleLegend}
        variant="outlined"
        onClick={onViewLegend}
      >
        {STR.labelLegend}
      </Button>
      <Grow in={Boolean(trSelecionado)} unmountOnExit>
        <Button
          variant="contained"
          color="warning"
          startIcon={<Icone icone="Edit" />}
          onClick={onEdit}
        >
          {STR.labelBtnEdit}
        </Button>
      </Grow>
      <Grow in={isAdmin && Boolean(trSelecionado)} unmountOnExit>
        <Button
          variant="outlined"
          color="error"
          title={STR.titleBtnDelete}
          startIcon={<Icone icone="Delete" />}
          onClick={() => onDeleteVoucher(trSelecionado)}
        >
          {STR.labelBtnDelete}
        </Button>
      </Grow>
    </Stack>
  );
};

Cashback.route = "/cashback";

export default Cashback;
